<template lang="pug">
    v-flex(xs12, style="max-width:400px;")
        //-v-card(color="transparent",flat,dark)
            v-card-text.pb-2.text-center
                h4 Ingreso al Sistema
        v-card.elevation-12(color="white", light, style="border-radius:10px;overflow:hidden;")
            v-toolbar(dark color="orange darken-2" dense flat)
              v-spacer
              v-toolbar-title(style="text-shadow: 0px 2px 3px rgba(0,0,0,0.6);") Ingreso al Sistema/Planillas
              v-spacer
            v-card-text
                v-text-field(
                    color="primary"
                    v-model="email"
                    prepend-icon="fas fa-envelope"
                    autofocus
                    label="Correo")
                v-text-field(
                    color="primary"
                    v-model="pass"
                    name="user",
                    label="Contraseña",
                    prepend-icon="fas fa-unlock-alt",
                    ref="passwordLogin",
                    :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'",
                    @click:append="changeIcon",
                    v-on:keyup.enter="tryLogin",
                    :type="showPassword ? 'password' : 'text'")
            v-divider
            v-card-actions
                //-v-btn(small, flat, color="primary").txtn.pl-1
                    v-icon.mr-1 lock
                    | Olvidó su contraseña ?
                v-btn(color="green" dark @click="clickDialogUsuario" class="text-initial" style="border-radius:5px")
                            v-icon(small) fas fa-user-friends
                            |&nbsp;Generar usuario
                v-spacer
                v-btn.txtn(
                    :loading="isLoading",
                    color="primary",
                    style="border-radius:5px",
                    @click="tryLogin") Ingresar
            //-v-divider
            //-v-card-actions
                v-spacer
                v-btn(color="green" dark @click="clickDialogUsuario" class="text-initial" style="border-radius:5px")
                            v-icon supervisor_account
                            |Generar usuario
                v-spacer
        div.content-recaptcha
            //-vue-recaptcha.text-center.hide-recaptcha-login(
                ref="refInvisibleRecaptcha",
                @verify="onVerifyInvisible",
                @expired="onExpiredInvisible",
                size="invisible",
                badge="inline",
                sitekey="6LcvWHwUAAAAABVDeanjR4WDV_m9DxWLffmj6oLQ")
        v-layout(row wrap v-if="!external")
            v-flex(xs12).text-center
                v-btn(large style="border-radius:5px" color="success" @click="abrirPrecarga").txtn Convocatorias Administrativas<br>(Personal sin RDA)
            //-2020-END-v-flex(xs12).text-center
                //-v-btn(large style="border-radius:5px" color="orange darken-2" @click="resultDialog = !resultDialog").txtn RESULTADOS DE LAS<br>CONVOCATORIAS
                v-btn(large style="border-radius:5px" color="orange darken-2" @click="openResult").txtn RESULTADOS DE LAS<br>CONVOCATORIAS
        v-dialog(v-model="loadingForm" width="300px" persistent)
            v-card(color="success", dark, v-if="isLoadingForm")
                v-card-text.text-center.pt-7
                    v-progress-circular(indeterminate)
                v-card-text.text-center
                    h4 Cargando formulario...
            v-card(color="success", dark, v-else)
                v-card-text.text-center.pt-7
                    v-icon(size=48) fas fa-check
                v-card-text.text-center(style="margin-top:-15px;")
                    h3 Formulario cargado !
                v-card-actions(style="margin-top:-15px;")
                    v-spacer
                    v-btn(color="white" light @click="abrirConvocatoriaSinRDA").txtn Abrir formulario
                    v-spacer
        v-dialog(v-model="fullDialog" fullscreen)
            v-card(flat style="width:100%;height:100%;overflow:hidden;")
                v-card-title.no-padding
                    v-toolbar(color='primary', dark='')
                        v-btn(color="success" style="border-radius:5px;" @click="fullDialog = !fullDialog")
                            v-icon fas fa-arrow-left
                            | &nbsp;Volver
                v-divider
                v-card-text.pa-2(:style="customHeight")
                    iframe(src="/ui/ui-distrito/sin-usuario/inscripcion-a-compulsa" width="100%" height="100%" style="overflow:hidden;" frameborder="0")
        v-dialog(v-model="dialogObtenerUsuario.estado",max-width="400px" persistent)
            c-obtener-usuario(v-if="dialogObtenerUsuario.estado" :onCancelar="clickNoDialogObtenerUsuario")
        //-v-dialog(v-model="resultDialog" fullscreen hide-overlay)
            v-card()
                v-toolbar(dark color="primary")
                    v-toolbar-title Resultados de las convocatorias
                    v-spacer
                    v-btn(icon dark @click="resultDialog = false")
                        v-icon fas fa-times
                //-v-card-text.no-padding
                iframe(src="https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf" width="100%" height="100%" style="overflow:hidden;height:100%;width:100%")
            //-iframe(src="http://sisep.minedu.gob.bo:8083/pdf/resultados.pdf")
        //-v-dialog(v-model="myPdf")
            iframe(src="http://docs.google.com/gview?embedded=true&url=http://www.orimi.com/pdf-test.pdf&amp;embedded=true")
            iframe(src="https://docs.google.com/viewerng/viewer?url=http://www.orimi.com/pdf-test.pdf&amp;embedded=true")
</template>
<script>
//import pdf from 'vue-pdf'
module.exports = {
  /*components:{
      pdf
  },*/
  data: function() {
    return {
      //-myPdf: true,
      fullDialog: false,
      resultDialog: false,
      email: "",
      pass: "",
      showPassword: true,
      //captchaVerified: false,
      captchaVerified: true,
      isLoading: false,
      loadingForm:false,
      isLoadingForm: true,
      dialogObtenerUsuario: {
        estado: false
      }
    };
  },
  props: {
    external: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customHeight: function() {
      return (
        "height:" +
        (this.$store.state.windowSize.h - 66) +
        "px;overflow:hidden;width:100%;"
      );
    }
  },
  methods: {
    openResult: function() {
        var win = window.open("/pdf/resultados.pdf", '_blank');
        win.focus();
    },
    abrirPrecarga: function() {
      this.isLoadingForm = true;
      this.loadingForm = true;
      var intervalInvisibleCaptcha = setInterval(function(){
        clearInterval(intervalInvisibleCaptcha);
        this.isLoadingForm = false;
      }.bind(this),10000);
    },
    abrirConvocatoriaSinRDA: function(){
        this.loadingForm = false;
        this.fullDialog = true;
    },
    someEnter: function() {
      return alert(":v");
    },
    onVerifyInvisible: function() {
      //console.log("ovc");
      this.captchaVerified = true;
    },
    onExpiredInvisible: function() {
      //console.log("oec");
      this.captchaVerified = false;
    },
    renderMode: function(id) {
      return alert("render: " + id);
    },
    verifyInvisibleRecaptcha: function() {
      if (!this.captchaVerified) {
        //console.log("vc");
        this.$refs.refInvisibleRecaptcha.execute();
        var count = 0;
					var intervalInvisibleCaptcha = setInterval(function(){
						count++;
            //console.log("ic");
						if(count>=15){
              //console.log("15c");
							clearInterval(intervalInvisibleCaptcha);
							this.$snotify.error("No se puede conectar con el servidor de recaptcha.\nverifique su conexión a internet.");
							this.isLoading = false;
						}
						if(this.captchaVerified){
              //console.log("14vc");
							clearInterval(intervalInvisibleCaptcha);
              this.isLoading = false;
							this.loginAction();
						}
						//console.log('counter='+count);
					}.bind(this),1000);
      }
      else{
        this.loginAction();
      }
    },
    changeIcon: function() {
      this.showPassword = !this.showPassword;
      return this.$refs.passwordLogin.focus();
    },
    tryLogin: function() {
      this.isLoading = true;
      this.verifyInvisibleRecaptcha();
      //return this.loginAction();
    },
    noCaptchaResponse: function() {
      this.$snotify.warning("No hay respuesta del servidor de recaptcha");
      return (this.isLoading = false);
    },
    loginAction: function() {
      //console.log("la")
      return axios({
        method: "POST",
        url: this.$store.state.URL_MANAGER + "/api/v1/oauth/token",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        data: {
          user: this.email,
          pass: this.pass
        }
      })
        .then(
          function(response) {
            if (response.data.code === 200) {
              this.$store.state.token = response.data.token.access_token;
              localStorage.setItem("auth", response.data.token.access_token);
              this.$store.state.user.username = response.data.user.user_name;
              this.$store.state.user.email = response.data.user.email;
              //this.$store.state.config.setConfig(response.data.services, response.data.apps, response.data.user);
              //this.$store.state.permisos(response.data.token.access_token);
			        //this.loginRda(); 2021
              this.$router.push("/");
            } else if (response.data.code === 401) {
              this.$snotify.error("No autorizado\n" + response.data.message);
            } else if (response.data.code === 422) {
              this.$snotify.warning("Error de validación");
            } else if (response.data.code === 405) {
              this.$snotify.warning(
                "Credenciales incorrectas\n Usuario no identificado"
              );
            } else {
              this.$snotify.error(
                "Servidor en mantenimiento\n Intente mas tarde"
              );
            }
            return (this.isLoading = false);
          }.bind(this)
        )
        ["catch"](
          function(error) {
            if(error.response){
              if(error.response.status){
                if(error.response.status == 404){this.$snotify.error("Servidor desconectado o en mantenimiento.");}
                else if(error.response.status == 401){this.$snotify.error("Usuario no identificado, revise su usuario o contraseña.");}
                else if(error.response.status == 406){this.$snotify.error("Usuario no identificado, revise su usuario o contraseña.");}
                else{this.$snotify.error(String(error.message));}
              }
              else{this.$snotify.error(String(error.message));}
            }
            else{this.$snotify.error(String(error.message));}
            return (this.isLoading = false);
          }.bind(this)
        );
    },
    clickDialogUsuario: function() {
      return (this.dialogObtenerUsuario.estado = true);
    },
    clickNoDialogObtenerUsuario: function() {
      return (this.dialogObtenerUsuario.estado = false);
    },
    loginRda: function() {
    	axios({
    		method: "POST",
	    	url: "/app/app-rda/oauth/token",
	    	data: {
     			client_id: 1,
     			client_secret: 'ZSisTCEmtpgrBXN9HKsULx68XC0okGBNZj3wbcPC',
     			grant_type: 'password',
     			username: this.email,
     			password: this.pass
 		   }
   		})
	   .then(function(response) {
        localStorage.setItem("auth_rda", response.data.access_token);
        this.$router.push("/");
       }.bind(this))
       .catch(function(error) {
		   console.log("loginForm")
		   console.log(error)
         this.$router.push("/");
   		}.bind(this))
	},
  },
  created: function() { }
};
</script>
